import { IStore } from "../types";

export function getPath({ router }: IStore): string {
  return router ? router.location.pathname : "";
}
